// /* eslint-disable react-refresh/only-export-components */
// /* eslint-disable @typescript-eslint/no-explicit-any */
// import axios from "axios";
//
// const ApiClient = (others: any) => {
//     const token = others.getState().auth.token != null && others.getState().auth.token != ""
//         ? others.getState().auth.token : localStorage.token
//
//     //axiosInstance
//     const axiosInstance = axios.create({
//         baseURL: import.meta.env.VITE_API_BASE_URL,
//         withCredentials: false,
//         headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//         },
//     });
//
//
//     //interceptors request
//     axiosInstance.interceptors.request.use(
//         function (config) {
//             config.headers.Authorization = `${token}`;
//             console.log("Url ===> ", config.baseURL! + config.url!)
//             console.log("Request ===> ", config.data)
//             return config;
//         },
//         function (error) {
//             // console.log("Request Error ===> ", error.message);
//             return Promise.reject(error);
//         }
//     );
//
//     //interceptors response
//     axiosInstance.interceptors.response.use(
//         (response) => {
//             if (response.data?.responseMessage?.includes('JWT')) {
//                 window.location.href = '/login'
//             }
//             console.log("Response ===> ", response.data)
//             return response;
//         },
//         (error) => {
//             if (error?.code == "ERR_NETWORK") {
//                 return {
//                     status: 503,
//                     statusText: 'Service unavailable',
//                     headers: {},
//                     config: {},
//                     request: {},
//                     data: {
//                         responseCode: "NetworkError",
//                         responseMessage: "Network Error, please check your connection"
//                     }
//                 }
//             }
//
//             if (error?.code == "ECONNABORTED") {
//                 return {
//                     status: 503,
//                     statusText: 'Service unavailable',
//                     headers: {},
//                     config: {},
//                     request: {},
//                     data: {
//                         responseCode: "RequestAbortedError",
//                         responseMessage: "Request Timed out, try again later"
//                     }
//                 }
//             }
//             console.log("Response Error ===> ", error.message);
//             return Promise.reject(error);
//         }
//     );
//     return axiosInstance;
// };
//
// export const BaseService = {
//     apiClient: ApiClient,
// };

// import {GetThunkAPI} from "@reduxjs/toolkit/dist/createAsyncThunk";
// import axios from "axios";
// import {RootState} from "@/store";
// import {ThunkApiConfig} from "@/util/type/StoreTypes.ts";
// import {appConfig} from "../../config/app-config.ts";
// import {NetworkHandlerHelper} from "@/util/helper/NetworkHandlerHelper.ts";
//
// const ApiClient = (others: GetThunkAPI<ThunkApiConfig>, isAuthorization: boolean = true) => {
//     const authState = (others.getState() as RootState).auth
//     //todo axiosInstance
//     const axiosInstance = axios.create({
//         baseURL: appConfig[`baseUrl${import.meta.env.VITE_APP_ENV}`],
//         withCredentials: false,
//         headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//         }
//     })
//
//      interceptors request

//     axiosInstance.interceptors.request.use(function (config) {
//         if (isAuthorization) {
//             config.headers.Authorization = `${authState?.token}`
//         }
//
//         // console.log("Headers ===> ", config.headers)
//         console.log("Url ===> ", config.baseURL! + config.url!)
//         console.log("Request ===> ", config.data)
//
//         if (config.method === 'post' || config.method === 'put') {
//             config.onUploadProgress = (progressEvent) => {
//                 const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total ? progressEvent.total : 1));
//                 console.log(`Upload progress: ${percentCompleted}%`);
//             };
//         }
//
//         if (config.method === 'get' && config.responseType === 'blob') {
//             config.onDownloadProgress = (progressEvent) => {
//                 const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total ? progressEvent.total : 1));
//                 console.log(`Download progress: ${percentCompleted}%`);
//             };
//         }
//
//         return config;
//     }, function (error) {
//         console.log("Request Error ===> ", error.response.data)
//         return Promise.reject(error);
//     });
//
//     //interceptors response
//     axiosInstance.interceptors.response.use((response) => {
//         console.log("Response ===> ", response.data)
//         if (response.data?.responseMessage?.includes('JWT')) {
//             others.dispatch(base.mutation.setModalOptions({
//                 component: ModalConstant.notificationModal,
//                 show: true,
//                 metadata: {
//                     notificationOptions: {
//                         title: "Session timeout",
//                         message: "Your session has timed out. Click to login again.",
//                         type: "warning",
//                         buttons: [
//                             {
//                                 title: "Proceed, to Login",
//                                 action: () => {
//                                     others.dispatch(auth.mutation.setToken(null))
//                                     others.dispatch(base.mutation.setCurrentRoutePath(window.location.pathname));
//                                     localStorage.removeItem('timeLeft');
//                                     window.location.href = RoutesConstant.auth.initialLogin
//                                     others.dispatch(base.mutation.resetModalOptions())
//                                 }
//                             }
//                         ]
//                     }
//                 }
//             }))
//         }
//         return response
//     }, (error) => {
//         console.log("Response Error ===> ", error.response.data)
//
//         const err = NetworkHandlerHelper.handle(error?.code)
//
//         return Promise.reject(err)
//     })
//     return axiosInstance
//
// }
//
//
// export const BaseService = {
//     apiClient: ApiClient,
// }


import {GetThunkAPI} from "@reduxjs/toolkit/dist/createAsyncThunk";
import axios, {CancelTokenSource} from "axios";
import {RootState} from "@/store";
import {ThunkApiConfig} from "@/util/type/StoreTypes.ts";
import {appConfig} from "../../config/app-config.ts";
import {NetworkHandlerHelper} from "@/util/helper/NetworkHandlerHelper.ts";
import {auth} from "@/store/modules/auth.ts";
import {RouteConstant} from "@/util/constant/RouteConstant.ts";
import {base} from "@/store/modules/base.ts";

const
    ApiClient = (others: GetThunkAPI<ThunkApiConfig>, isAuthorization: boolean = true, cancelToken?: CancelTokenSource) => {
        const authState = (others.getState() as RootState).auth;
        // const navigate = useNavigate()

        const axiosInstance = axios.create({
            baseURL: appConfig[`baseUrl${import.meta.env.VITE_APP_ENV}`],
            withCredentials: false,
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            }
        });

        // Request interceptor
        axiosInstance.interceptors.request.use(function (config) {
            if (isAuthorization) {
                config.headers.Authorization = `${authState?.token}`;
            }
            // console.log("Url ===> ", config.baseURL! + config.url!);
            // console.log("Request ===> ", config.data);

            if (config.method === 'post' || config.method === 'put') {
                config.onUploadProgress = (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total ? progressEvent.total : 1));
                    console.log(`Upload progress: ${percentCompleted}%`);
                };
            }

            if (config.method === 'get' && config.responseType === 'blob') {
                config.onDownloadProgress = (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total ? progressEvent.total : 1));
                    console.log(`Download progress: ${percentCompleted}%`);
                };
            }

            if (cancelToken) {
                config.cancelToken = cancelToken.token;
            }

            return config;
        }, function (error) {
            console.log("Request Error ===> ", error.response?.data);
            return Promise.reject(error);
        });

        // Response interceptor
        axiosInstance.interceptors.response.use((response) => {
            if (response.data?.responseMessage?.includes('JWT')) {
                others.dispatch(auth.mutation.setToken(""))
                window.location.href = RouteConstant.auth.login.path
                indexedDB.deleteDatabase("qoonity-portal")
                others.dispatch(base.mutation.resetModalOptions())
                // others.dispatch(base.mutation.setModalOptions({
                //     show: true,
                //     component: ModalConstant.deleteEntity
                // }))
                // navigate(RouteConstant.auth.login.path)
            }
            // console.log("Response ===> ", response.data)
            return response;
        }, (error) => {
            console.log("Response Error ===> ", error.response?.data);

            const err = NetworkHandlerHelper.handle(error?.code);
            return Promise.reject(err);
        });

        return axiosInstance;
    };

export const BaseService = {
    apiClient: ApiClient,
};
